import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { CartState, initialCartState } from './types'

export const cart: Module<CartState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialCartState),
  actions,
  getters,
  mutations,
}
